import React from "react";

export default function TxnIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41741 7.48429L6.137 1.63397C6.31467 1.41373 6.6705 1.53936 6.6705 1.82233V4.00599C6.6705 4.17168 6.80481 4.30599 6.9705 4.30599H16.7234C16.8891 4.30599 17.0234 4.4403 17.0234 4.60599V7.67266C17.0234 7.83834 16.8891 7.97266 16.7234 7.97266H1.6509C1.39878 7.97266 1.25911 7.68052 1.41741 7.48429Z"
        stroke="white"
      />
      <path
        d="M16.6295 11.461L11.9099 17.3113C11.7322 17.5316 11.3764 17.406 11.3764 17.123V14.9393C11.3764 14.7736 11.2421 14.6393 11.0764 14.6393H1.32344C1.15775 14.6393 1.02344 14.505 1.02344 14.3393V11.2727C1.02344 11.107 1.15775 10.9727 1.32344 10.9727H16.396C16.6481 10.9727 16.7878 11.2648 16.6295 11.461Z"
        stroke="white"
      />
    </svg>
  );
}
